import { render, staticRenderFns } from "./BaseAsideNavItem.vue?vue&type=template&id=3ed76c71&scoped=true&"
import script from "./BaseAsideNavItem.vue?vue&type=script&lang=js&"
export * from "./BaseAsideNavItem.vue?vue&type=script&lang=js&"
import style0 from "./BaseAsideNavItem.vue?vue&type=style&index=0&id=3ed76c71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed76c71",
  null
  
)

export default component.exports